import React, {Component} from "react";

class BgGrid extends Component {
    VB = 1000;
    hSizeBoost = 1;
    vSizeBoost = 1;
    strokeWidthV: 1;
    strokeWidthH: 1;
    baseOpacity = 0.2;
    opacityBoost = 3;
    me = React.createRef();

    constructor(props) {
        super(props);

        const {shapes, vLines, hLines, hlHeigth, fill, stroke, strokeOpacity, ...divProps} = props;

        this.divProps = divProps;

        this.state = {
            fill: fill ?? 'transparent',
            stroke: stroke ?? '#AAAAAA',
            strokeOpacity: strokeOpacity ?? this.baseOpacity,
            vLines: vLines ?? 7,
            hLines: hLines ?? 5,
            hlHeigth: hlHeigth ?? 20, // vh
            shapes: shapes ?? [],
        }
    }

    componentDidMount() {
        this.vSizeBoost = (window.innerHeight / this.me.current.offsetHeight);
        this.hSizeBoost = (window.innerWidth / this.me.current.offsetWidth);
    }

    getX = (x) => (this.VB / this.state.vLines) * x
    getY = (y) => (this.VB / this.state.hLines) * y

    drawLine = (id, x1, x2, y1, y2, size, color, opacity, sw) =>
        <line key={id} id={id}
              stroke={color ?? this.state.stroke}
              strokeWidth={sw}
              strokeOpacity={opacity ?? this.state.strokeOpacity}
              x1={x1} x2={x2}
              y1={y1} y2={y2} />

    drawLineH = (id, x, y, size, color, opacity) =>
        this.drawLine(id + 'H',
        size? this.getX(x) - (size * this.hSizeBoost): 0, size? this.getX(x) + (size * this.hSizeBoost): this.VB,
            this.getY(y), this.getY(y),
            size, color, opacity, this.strokeWidthH)

    drawLineV = (id, x, y, size, color, opacity) =>
        this.drawLine(id + 'V',
            this.getX(x), this.getX(x),
            size? this.getY(y) - (size * this.vSizeBoost): 0, size? this.getY(y) + (size * this.vSizeBoost): this.VB,
            size, color, opacity, this.strokeWidthV)

    drawLines(max: number, horizontal: boolean) {
        const elements = [];
        for(let i =0; i <= max; i++){
            if (horizontal)
                elements.push(this.drawLineH(this.props.id + i, i, i));
            else
                elements.push(this.drawLineV(this.props.id + i, i, i));
        }
        return elements;
    }

    getContent() {
        const content = []
        content.push(this.drawLines(this.state.hLines, true));
        content.push(this.drawLines(this.state.vLines, false));
        this.state.shapes.map(value => {
            const o = this.baseOpacity * (value.opacityBoost ?? this.opacityBoost)
            if (value.shape !== 'H')
                content.push(this.drawLineV(value.id, value.x, value.y, value.size, value.color, o));
            if (value.shape !== 'V')
                content.push(this.drawLineH(value.id, value.x, value.y, value.size, value.color, o));
            return value;
        });
        return content;
    }

    getHeight = () => this.state && this.state.hlHeigth? this.state.hlHeigth * this.state.hLines + 'vh' : '100%'

    render() {
        return ( !this.state? <></>:
            <div {...this.divProps} ref={this.me}
                style={{height: this.getHeight(), width: '100%', position: 'absolute', opacity: 1 }}>
                <svg xmlns='http://www.w3.org/2000/svg'
                     xmlnsXlink='http://www.w3.org/1999/xlink'
                     viewBox={'0 0 ' + this.VB + ' ' + this.VB}
                     width={'100%'}
                     height={'100%'}
                     fill={this.state.fill}
                     stroke={this.state.stroke}
                     strokeOpacity={this.state.strokeOpacity}
                     strokeWidth={this.state.strokeWidth}
                     preserveAspectRatio='none'
                >
                    {this.getContent()}
                </svg>
            </div>
        );
    }
}

export default BgGrid;
